<template>
  <Teleport to="body">
    <div
      class="modal fade"
      id="adminChangePasswordModal"
      tabindex="-1"
      ref="pwdModalRef"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-4 overflow-hidden">
          <div class="modal-header bg-dark text-white border-0">
            <h5 class="modal-title fw-bold">
              <i class="bi bi-shield-lock-fill me-2"></i>เปลี่ยนรหัสผ่าน (Change
              Password)
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              @click="closeModal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body p-4 bg-light">
            <form @submit.prevent="submitChangePassword">
              <div class="mb-3">
                <label class="form-label small fw-bold text-muted"
                  >รหัสผ่านเดิม</label
                >
                <div class="input-group">
                  <span class="input-group-text bg-white"
                    ><i class="bi bi-key-fill text-secondary"></i
                  ></span>
                  <input
                    type="password"
                    class="form-control"
                    v-model="form.old_password"
                    required
                    placeholder="กรอกรหัสผ่านเดิมของคุณ"
                  />
                </div>
              </div>

              <hr class="my-4 text-muted" />

              <div class="mb-3">
                <label class="form-label small fw-bold text-muted"
                  >รหัสผ่านใหม่ <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <span class="input-group-text bg-white"
                    ><i class="bi bi-lock-fill text-primary"></i
                  ></span>
                  <input
                    type="password"
                    class="form-control"
                    v-model="form.new_password"
                    required
                    placeholder="อย่างน้อย 6 ตัวอักษร"
                    minlength="6"
                  />
                </div>
              </div>

              <div class="mb-4">
                <label class="form-label small fw-bold text-muted"
                  >ยืนยันรหัสผ่านใหม่ <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <span class="input-group-text bg-white"
                    ><i class="bi bi-check-circle-fill text-success"></i
                  ></span>
                  <input
                    type="password"
                    class="form-control"
                    v-model="form.confirm_password"
                    required
                    placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
                    minlength="6"
                  />
                </div>
                <div
                  v-if="
                    form.new_password &&
                    form.confirm_password &&
                    form.new_password !== form.confirm_password
                  "
                  class="text-danger small mt-1"
                >
                  <i class="bi bi-exclamation-circle"></i> รหัสผ่านใหม่ไม่ตรงกัน
                </div>
              </div>

              <div class="d-grid">
                <button
                  type="submit"
                  class="btn btn-dark rounded-pill fw-bold py-2 shadow-sm"
                  :disabled="
                    isSubmitting || form.new_password !== form.confirm_password
                  "
                >
                  <span
                    v-if="isSubmitting"
                    class="spinner-border spinner-border-sm me-2"
                  ></span>
                  <i class="bi bi-save-fill me-1" v-else></i> บันทึกรหัสผ่านใหม่
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, onMounted } from "vue";
import adminApi from "@/utils/adminApi";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";

const pwdModalRef = ref(null);
let modalInstance = null;
const isSubmitting = ref(false);

const form = ref({
  old_password: "",
  new_password: "",
  confirm_password: "",
});

onMounted(() => {
  // สร้าง Instance ทันทีที่โหลด
  modalInstance = new Modal(pwdModalRef.value);
});

// ฟังก์ชันเปิด Modal
const openModal = () => {
  form.value = { old_password: "", new_password: "", confirm_password: "" };
  if (modalInstance) {
    modalInstance.show();
  }
};

// 🟢 [NEW] ฟังก์ชันปิด Modal
const closeModal = () => {
  if (modalInstance) {
    modalInstance.hide();
  }
};

const submitChangePassword = async () => {
  if (form.value.new_password !== form.value.confirm_password) return;

  isSubmitting.value = true;
  try {
    const res = await adminApi.put(
      "/api/admin/auth/change-password",
      form.value,
    );
    if (res.data.success) {
      closeModal(); // สั่งปิดเมื่อสำเร็จ
      Swal.fire({
        icon: "success",
        title: "สำเร็จ!",
        text: "รหัสผ่านของคุณถูกเปลี่ยนเรียบร้อยแล้ว",
        confirmButtonColor: "#212529",
      });
      form.value = { old_password: "", new_password: "", confirm_password: "" };
    }
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "ผิดพลาด",
      text: err.response?.data?.message || "ไม่สามารถเปลี่ยนรหัสผ่านได้",
      confirmButtonColor: "#d33",
    });
  } finally {
    isSubmitting.value = false;
  }
};

// Expose ให้ไฟล์อื่นเรียกใช้
defineExpose({ openModal });
</script>
